<template>
    <v-card
        flat
        elevation="0"
        class=""
        :loading="flags.loading"
    >
        <v-form :disabled="flags.loading">
            <v-container>
                <v-card-title>
                    <span class="header3">{{ $tc('reports.edit_form.title') }}</span>
                    <span class="header3">&nbsp;|&nbsp;</span>
                    <span class="subtitle">{{ reportTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-col cols="12" class="px-0">
                        <span class="label">{{ $tc('reports.title') }}:</span>
                        <v-text-field
                            v-model="currentReport.title"
                            outlined
                            class="input-text input-text--textfield body-text small"
                            hide-details="auto"
                            dense
                        />
                    </v-col>
                    <div v-if="canChangeStatus">
                        <v-col cols="12" class="px-0">
                            <span class="label">{{ $tc('reports.status') }}:</span>
                            <v-select
                                v-model="currentReport.status"
                                :items="statuses"
                                item-value="id"
                                item-text="name"
                                outlined
                                dense
                                class="input-text input-text--select body-text"
                                hide-details="auto"
                            />
                        </v-col>
                    </div>
                </v-card-text>

                <v-card-actions class="justify-center">
                    <v-btn
                        class="v-btn--primary"
                        text
                        @click="save"
                        :disabled="flags.loading || !formHasChanged"
                    >{{ $t('app.save') }}</v-btn>

                    <v-btn
                        class="v-btn--secondary ml-3"
                        text
                        @click="closeDialog"
                    >{{ $t('app.cancel') }}</v-btn>
                </v-card-actions>
            </v-container>
        </v-form>
    </v-card>
</template>

<script>
import {ReportModelFactory} from "@/Repositories/Reports/Factories/ReportModelFactory";
import ReportsIndexRepository from "@/Repositories/Reports/ReportsIndexRepository";
import {i18n} from "@/i18n";
import {mapActions} from "pinia";
import {ReportsStore} from "@/Store/Reports/ReportsStore";
import ToastMixin from "@/Shared/toastMixin";
import _ from "lodash";

export default {
    name: "EditForm",

    props: {
        report: {
            type: Object,
            required: true,
        },
        reportType: {
            type: Object,
            required: true,
        }
    },

    mixins: [ToastMixin],

    data (){
        return {
            currentReport: new ReportModelFactory(this.reportType.name),

            flags: {
                loading: false,
            },
        }

    },

    methods: {

        /**
         * Closes dialog
         */
        closeDialog() {
            this.$root.$emit('cancelReportUpdate');
        },

        /**
         *
         */
        cloneReport() {
            this.currentReport = _.cloneDeep(this.report);
        },

        /**
         * @returns {Promise<void>}
         */
        async save() {
            try {
                this.flags.loading = true;

                await this.updateReport(this.currentReport);

                this.toast().success(
                    this.$t('reports.edit_form.success_update_title', {report: this.report.title}),
                    this.$t('reports.edit_form.success_update_message'),
                );

                this.$root.$emit('reports.management.report_updated', _.cloneDeep(this.currentReport))

                this.closeDialog();

            } catch (ex) {

                this.toast().error(
                    this.$t('reports.edit_form.error_update_title'),
                    this.$t('reports.edit_form.error_update_message'),
                );

                console.error('Report update exception', ex.response);

            } finally {

                this.flags.loading = false;
            }
        },

        /**
         *
         */
        ...mapActions(ReportsStore, [
            'updateReport',
        ]),
    },

    computed: {

        /**
         *
         * @returns {boolean}
         */
        canChangeStatus() {
            return ['GENERATED', 'IN_REVIEW'].includes(this.report.status);
        },

        /**
         *
         * @returns {Status[]|Promise<[string]>|*}
         */
        statuses() {
            return ReportsIndexRepository
                .getStatuses()
                .filter(status => ['IN_REVIEW', 'CLOSED', 'GENERATED'].includes(status.id))
                .map(
                    status => Object.assign(status, {
                        name: i18n.t(`reports.statuses.${status.id}`)
                    })
                );
        },

        /**
         *
         * @returns {*}
         */
        reportTitle() {
            return this.report.title;
        },

        /**
         *
         * @returns {boolean}
         */
        formHasChanged() {
            return !_.isEqual(this.report, this.currentReport);
        }
    },

    mounted() {
        this.cloneReport();
    },
}
</script>

<style scoped>

</style>
